import { render } from "./TableDropdown.vue?vue&type=template&id=0c5ff0d6"
import script from "./TableDropdown.vue?vue&type=script&lang=js"
export * from "./TableDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yaakovbeckerman/projects/vue-notus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__